import { AppTreeSide, UniDateRangePicker, Bar } from 'components'
import ShowAlarmEvent from '../../common/showAlarmEvent'
import ShowDataNode from '../../common/showDataNode'
import HandleAlarmEventModal from '../../common/handleAlarmEventModal'
import MapNavigator from '../../common/mapNavigator'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {loadRegionTree} from '@/utils/tree'
import {getOneWeekBeginAndEndDate, formatDateDifference} from '@/utils/date'

// 火灾报警系统种类值
let fireFightingSystemSystemKind = 3200

const alarmTimesRankingBarColor = ['#4CA2EB']

export default {
  name: 'FireFightingSystem',
  data () {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 底部栏打开标志
      footerOpen: true,
      // 树数据
      treeData: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 树查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 活动页面索引
      activeTabName: '0',
      // 遮罩层
      loading: false,
      // 数据列表页面--------------------------------------------------------------------------------------------------
      // 卡片数据
      cardData: [], // 固定为3行4列
      cardTotalItem: 0, // 记录总数
      cardMaxRowCount: 3, // 当前页卡片最大行数
      cardMaxColCount: 4, // 当前页卡片最大列数
      cardRowCount: 0, // 当前页卡片实际行数
      cardColCountPerRows: [], // 当前页卡片每行列数
      lastDataNodeUpdateDateTime: 0,
      // 卡片查询条件
      cardQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        gaugedObjectKind: 255,
        alarmStates: [],
        systemKind: fireFightingSystemSystemKind, // 火灾报警
        encoderStateRequired: 1, // 要求返回监控设备状态
        beginUpdateDateTime: 0,
        pageNum: 1,
        pageSize: 12
      },
      pageTotalCount: 0,
      pageNormalCount: 0,
      pageAlarmCount: 0,
      pageErrorCount: 0,
      // 卡片当前项
      cardCurrentItem: null,
      // 数据节点信息弹窗
      showDataNodeModalOpen: false,
      // 画面组态页面--------------------------------------------------------------------------------------------------
      // 查询条件
      mapQueryParams: {
        mapId: 0,
        regionId: -1,
        systemKind: fireFightingSystemSystemKind // 火灾报警
      },
      mapNavigatorHeightExpired: true,
      // 事件记录页面--------------------------------------------------------------------------------------------------
      // 表格数据
      eventTableData: [],
      eventTableTotalRow: 0,
      lastEventId: 0,
      // 表格查询条件
      eventDates: [], // 查询起始和结束日期
      eventTableQueryParams: {
        lastEventId: 0,
        regionId: -1,
        objectId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        resourceSubType: 255,
        systemKind: fireFightingSystemSystemKind, // 火灾报警
        alarmStates: [],
        beginHappenDateTime: 0,
        endHappenDateTime: 0,
        handleStates: [], // 处理状态数组
        orderBy: 1, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 事件表格当前行
      eventTableCurrentRow: null,
      // 事件信息弹窗
      showEventModalOpen: false,
      // 处理告警事件弹窗
      handelAlarmEventModalOpen: false,
      // 统计分析页面--------------------------------------------------------------------------------------------------
      alarmTimesRankingBarId: 'alarm-times-ranking-bar',
      alarmTimesRankingBarData: [['数据节点', '告警次数']], // xAxis-数据节点，yAxis-告警次数,
      alarmTimesRankingBarColor: alarmTimesRankingBarColor,
      // bar查询条件
      alarmTimesRankingBarQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        resourceKind: 255,
        gaugedObjectKind: 255,
        alarmStates: [],
        systemKind: fireFightingSystemSystemKind, // 火灾报警
        orderBy: 3, // 按告警次数减序排列
        pageNum: 1,
        pageSize: 10
      },
      // 轮巡定时器
      pollingTimer: null
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker,
    Bar,
    ShowDataNode,
    ShowAlarmEvent,
    HandleAlarmEventModal,
    MapNavigator
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  created() {
    // 显示或隐藏树侧边栏
    this.treeSideBarOpen = this.$globalConfig.treeSideBarOpen
    if (this.$route.query.treeSideBarOpen) {
      this.treeSideBarOpen = this.$route.query.treeSideBarOpen === '1' || this.$route.query.treeSideBarOpen === 'true'
    }
    // 根据浏览器宽度显示/隐藏底部控制栏
    if (window.outerWidth <= 1366) {
      this.footerOpen = false
    }

    // 根据卡片最大行数和最大列数返回页数
    this.cardQueryParams.pageSize = this.cardMaxRowCount * this.cardMaxColCount
  },
  mounted () {
    // 设置查询起始日期和截止日期
    this.eventDates = getOneWeekBeginAndEndDate() // 近一周

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()

      // 开始数据轮巡
      this.startDataPolling()
    })
  },
  beforeDestroy() {
    // 停止数据轮巡
    this.stopDataPolling()
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    toggleFooter() {
      this.footerOpen = !this.footerOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点或根节点的首个子节点为当前节点
            let currentKey = null
            if (this.$globalConfig.currentRegionSynchEnabled && this.$store.getters.appCurrentRegionKey) { // 区域同步选择启用
              currentKey = this.$store.getters.appCurrentRegionKey
            } else {
              if (this.$globalConfig.defaultCurrentTreeNode === 0) { // 根节点
                currentKey = this.treeData[0].key
              } else if (this.$globalConfig.defaultCurrentTreeNode === 1) { // 根节点的首个子节点
                currentKey = this.treeData[0].children.length > 0 ? this.treeData[0].children[0].key : this.treeData[0].key
              }
            }
            if (currentKey) {
              this.$refs.tree.setCurrentKey(currentKey)
              // 单击当前节点
              this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
            }
            // 只有一个树节点自动隐藏侧边栏
            if (this.treeData[0].children.length === 0) {
              this.treeSideBarOpen = false
            }
          }
        })
      })
    },
    // 查询数据节点列表
    getDataNodeList() {
      this.loading = true
      this.lastDataNodeUpdateDateTime = 0
      this.cardQueryParams.beginUpdateDateTime = 0
      this.$http(this.$api.dataNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200) {
            this.cardData = res.data
            this.cardTotalItem = res.page.totalRow
            res.data.forEach(item => {
              item.strAlarmElapsedTime = formatDateDifference(new Date(item.happenTime * 1000), new Date(), 2) // 统计累计正常时间（最后一次告警发生后经过的时间）
              if (item.updateDateTime > this.lastDataNodeUpdateDateTime) { // 更新最后更新日期时间
                this.lastDataNodeUpdateDateTime = item.updateDateTime
              }
            })

            // 计算卡片行数
            this.cardRowCount = Math.ceil(this.cardData.length / this.cardMaxColCount) // 向上取整
            // 计算卡片每行列数
            this.cardColCountPerRows = []
            for (let i = 0; i < this.cardRowCount; ++i) {
              this.cardColCountPerRows[i] = (this.cardData.length - this.cardMaxColCount * i) / this.cardMaxColCount >= 1 ? this.cardMaxColCount : (this.cardData.length - this.cardMaxColCount * i) % this.cardMaxColCount
              this.cardColCountPerRows[i] = Math.abs(this.cardColCountPerRows[i]) // 余数可能为负，需取绝对值
            }

            if (res.data.length) {
              if (this.cardCurrentItem === null) {
                this.cardCurrentItem = res.data[0] // 选中首项
              } else {
                this.cardCurrentItem = this.getRecordById(this.cardCurrentItem.id, res.data)
                if (this.cardCurrentItem === null) { // 数组是否包含选中项
                  this.cardCurrentItem = res.data[0] // 选中首项
                }
              }
            }
            // 统计当前页面节点数量
            this.statPageDataNodeCount()
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },

    // 查询更新的数据节点列表
    getUpdatedDataNodeList() {
      this.loading = true
      this.cardQueryParams.beginUpdateDateTime = this.lastDataNodeUpdateDateTime + 1
      this.$http(this.$api.dataNodeList, this.cardQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => { // 更新数据节点数据
              item.strAlarmElapsedTime = formatDateDifference(new Date(item.happenTime * 1000), new Date(), 2) // 统计累计正常时间（最后一次告警发生后经过的时间）
              for (let index in this.cardData) {
                if (this.cardData[index].id === item.id) {
                  this.cardData[index] = item
                  break
                }
              }
              if (item.updateDateTime > this.lastDataNodeUpdateDateTime) { // 更新最后更新日期时间
                this.lastDataNodeUpdateDateTime = item.updateDateTime
              }
            })

            // 统计当前页面节点数量
            this.statPageDataNodeCount()
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询事件列表
    getHistoryEventList() {
      if (this.lastEventId > 0 &&
        this.lastEventId >= this.$store.getters.appLastEventId) { // 检测是否有新事件
        return
      }

      this.loading = true
      this.eventTableQueryParams.beginHappenDateTime = this.eventDates[0].getTime() / 1000
      this.eventTableQueryParams.endHappenDateTime = this.eventDates[1].getTime() / 1000
      this.$http(this.$api.historyEventList, this.eventTableQueryParams).then(
        res => {
          if (res.code === 200) {
            res.data.forEach(item => { // 更新最大事件id
              if (item.id > this.lastEventId) {
                this.lastEventId = item.id
              }
            })
            this.eventTableData = res.data
            this.eventTableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询数据节点告警次数列表
    getDataNodeAlarmTimesList() {
      return new Promise((resolve, reject) => {
        this.loading = true
        this.$http(this.$api.dataNodeList, this.alarmTimesRankingBarQueryParams).then(
          res => {
            if (res.code === 200) {
              this.alarmTimesRankingBarData = [['数据节点', '告警次数']]
              if (res.data.length) {
                res.data.forEach(item => {
                  this.alarmTimesRankingBarData.push([item.name, item.alarmTimes])
                })
              }
              this.$nextTick(() => {
                this.$refs.alarmTimesRankingBar.draw()
              })
            }
            this.loading = false
            resolve(res)
          }
        ).catch(err => {
          console.log(err)
          this.loading = false
          reject(err)
        })
      })
    },
    // 统计当前页面节点数量
    statPageDataNodeCount() {
      this.pageTotalCount = 0
      this.pageNormalCount = 0
      this.pageAlarmCount = 0
      this.pageErrorCount = 0
      if (this.cardTotalItem === 0) {
        return
      }

      this.cardData.forEach(item => {
        ++this.pageTotalCount
        if (item.alarmState === 0) {
          ++this.pageNormalCount
        } else if (item.alarmState === 1) {
          if (item.resourceKind === 22) {
            if (item.eventTypeSet === 0x04) {
              ++this.pageErrorCount
            } else {
              ++this.pageAlarmCount
            }
          } if (item.resourceKind === 23) {
            if (item.eventTypeSet === 0x20) {
              ++this.pageErrorCount
            } else {
              ++this.pageAlarmCount
            }
          }
        }
      })
    },
    // 开始数据轮巡
    startDataPolling() {
      this.pollingTimer = setInterval(() => {
        if (this.loading) { // 检测上一次查询是否尚未结束
          return
        }
        if (this.activeTabName === '0') {
          if (this.showDataNodeModalOpen) { // 暂停刷新数据
            return
          }
          this.cardData.length ? this.getUpdatedDataNodeList() : this.getDataNodeList()
        } else if (this.activeTabName === '2') {
          // this.getHistoryEventList()
        } else if (this.activeTabName === '3') {
          // this.getDataNodeAlarmTimesList().then(res => {
          // })
        }
      }, this.$globalConfig.pagePollingInterval)
    },
    // 停止数据轮巡
    stopDataPolling() {
      if (this.pollingTimer != null) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (this.activeTabName === '0') {
        if (this.cardQueryParams.regionId !== obj.id) {
          this.cardQueryParams.regionId = obj.id
          this.cardQueryParams.pageNum = 1
          this.getDataNodeList()
        }
      } else if (this.activeTabName === '1') {
        if (this.mapQueryParams.regionId !== obj.id) {
          this.mapQueryParams.regionId = obj.id
          if (this.mapNavigatorHeightExpired) {
            setTimeout(() => { // 由于切换页面后monitoringContent高度可能会发生变化，必须等待appTreeSide高度调整完毕才能同步高度
              if (this.$refs.mapNavigator.$el.clientHeight < this.$refs.monitoringContent.clientHeight - 70) { // 设置地图浏览器高度
                let contentHeight = this.$refs.monitoringContent.clientHeight - 70
                this.$refs.mapNavigator.$el.style.height = contentHeight + 'px'
              }
              this.$refs.mapNavigator.switchMap(this.mapQueryParams.mapId, this.mapQueryParams.regionId, this.mapQueryParams.systemKind)
              this.mapNavigatorHeightExpired = false
            }, 500)
          } else {
            this.$nextTick(() => {
              this.$refs.mapNavigator.switchMap(this.mapQueryParams.mapId, this.mapQueryParams.regionId, this.mapQueryParams.systemKind)
            })
          }
        }
      } else if (this.activeTabName === '2') {
        if (this.eventTableQueryParams.regionId !== obj.id) {
          this.eventTableQueryParams.regionId = obj.id
          this.eventTableQueryParams.pageNum = 1
          this.getHistoryEventList()
        }
      } else if (this.activeTabName === '3') {
        if (this.alarmTimesRankingBarQueryParams.regionId !== obj.id) {
          this.alarmTimesRankingBarQueryParams.regionId = obj.id
          this.alarmTimesRankingBarQueryParams.pageNum = 1
          this.getDataNodeAlarmTimesList().then(res => {
          })
        }
      }

      if (this.$globalConfig.currentRegionSynchEnabled) { // 当前区域同步启用
        this.$store.commit('app/SET_CURRENT_REGION_KEY', obj.key) // 更新当前区域key
      }
    },
    // tab页面切换
    handleTabClick(tab) {
      if (this.activeTabName === '1') { // 组态画面
        this.mapNavigatorHeightExpired = true // 切换页面后monitoringContent高度可能会发生变化
      }

      let currentNode = this.$refs.tree.getCurrentNode()
      if (currentNode) {
        this.handleTreeNodeClick(currentNode)
      }
    },
    // 数据列表页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleFormQuery() {
      this.cardQueryParams.page = 1
      this.getDataNodeList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.cardQueryParams.regionId = 0
      this.cardQueryParams.nodeId = 0
      this.cardQueryParams.descendantRegionRequired = 1
      this.cardQueryParams.resourceKind = 255
      this.cardQueryParams.gaugedObjectKind = 255
      this.cardQueryParams.alarmStates = []
      this.cardQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.cardQueryParams.pageNum = val
      this.getDataNodeList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.cardQueryParams.pageSize = val
      this.getDataNodeList()
    },
    // 表格当前记录改变
    handleTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }
      this.cardCurrentItem = currentRow
    },
    // 查看数据节点信息
    handleDataNodeView(item) {
      if (item) {
        this.cardCurrentItem = item // 选中当前项
        this.showDataNodeModalOpen = true
      }
    },
    // 数据节点信息取消提交
    handleShowDataNodeModalCancel() {
      this.showDataNodeModalOpen = false
    },
    // 布撤防
    handleDeploy() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      let queryText = this.cardCurrentItem.deployed ? '您确定撤防【' : '您确定布防【'
      queryText += this.cardCurrentItem.name
      queryText += '】吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let deployParams = {
          nodeId: this.cardCurrentItem.id,
          enabled: this.cardCurrentItem.deployed
        }
        this.$http(this.$api.alarmDeploy, deployParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 消警
    handleCancelAlarm() {
      if (this.cardCurrentItem == null) {
        this.$messagebox.confirm('请先选中一条记录！', '提示', {
          confirmButtonText: '知道了',
          showCancelButton: false,
          type: 'warning'
        })
        return
      }

      let queryText = '您确定对【'
      queryText += this.cardCurrentItem.name
      queryText += '】进行消警操作吗?'
      this.$messagebox.confirm(queryText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let cancelAlarmParams = {
          nodeId: this.cardCurrentItem.id
        }
        this.$http(this.$api.cancelAlarm, cancelAlarmParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 全布防
    handleDeployAll() {
      this.$messagebox.confirm('您确定布防当前页面全部节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nodeIds = []
        this.cardData.forEach(item => {
          nodeIds.push(item.id)
        })
        let deployParams = {
          nodeIds: nodeIds,
          enabled: 1
        }
        this.$http(this.$api.alarmDeploy, deployParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 全撤防
    handleUndeployAll() {
      this.$messagebox.confirm('您确定撤防当前页面全部节点吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nodeIds = []
        this.cardData.forEach(item => {
          nodeIds.push(item.id)
        })
        let deployParams = {
          nodeIds: nodeIds,
          enabled: 0
        }
        this.$http(this.$api.alarmDeploy, deployParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 全消警
    handleCancelAllAlarms() {
      this.$messagebox.confirm('您确定对当前页面全部节点进行消警操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let nodeIds = []
        this.cardData.forEach(item => {
          nodeIds.push(item.id)
        })
        let cancelAlarmParams = {
          nodeIds: nodeIds
        }
        this.$http(this.$api.cancelAlarm, cancelAlarmParams).then(
          res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 事件记录页面------------------------------------------------------------------------------------------------
    // 查询按钮操作
    handleEventFormQuery() {
      this.eventTableQueryParams.page = 1
      this.getHistoryEventList()
    },
    // 重置按钮操作
    resetEventQueryForm() {
      this.eventTableQueryParams.regionId = 0
      this.eventTableQueryParams.objectId = 0
      this.eventTableQueryParams.descendantRegionRequired = 1
      this.eventTableQueryParams.resourceKind = 255
      this.eventTableQueryParams.resourceSubType = 255
      this.eventTableQueryParams.alarmStates = []
      this.eventDates = getOneWeekBeginAndEndDate() // 近一周
      this.eventTableQueryParams.beginHappenDateTime = 0
      this.eventTableQueryParams.endHappenDateTime = 0
      this.eventTableQueryParams.handleStates = []
      this.eventTableQueryParams.pageNum = 1
      this.$refs['eventQueryForm'].resetFields()
      this.handleEventFormQuery()
    },
    // 分页
    handleEventCurrentPageChange(val) {
      this.eventTableQueryParams.pageNum = val
      this.getHistoryEventList()
    },
    // 页面条数改变
    handleEventPageSizeChange(val) {
      this.eventTableQueryParams.pageSize = val
      this.getHistoryEventList()
    },
    // 表格选中记录改变
    handleEventTableSelectionChange(selection) {
      this.eventTableSelectedIds = selection.map(item => item.id)
    },
    // 表格当前记录改变
    handleEventTableCurrentChange(currentRow, oldCurrentRow) {
      if (currentRow == null) {
        return
      }

      this.eventTableCurrentRow = currentRow
    },
    // 查看事件信息
    handleEventView(row) {
      if (row && row.id) {
        this.$refs.eventTable.setCurrentRow(row) // 选中当前行
        this.showEventModalOpen = true
      }
    },
    // 处理事件
    handleEventHandle(row) {
      if (row && row.id) {
        this.$refs.eventTable.setCurrentRow(row) // 选中当前行
        this.handelAlarmEventModalOpen = true
      } else if (this.eventTableSelectedIds.length > 0) {
        this.$messagebox.confirm('您确定批量确认选中的' + this.eventTableSelectedIds.length + '条记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http(this.$api.confirmAlarm, {
            eventIds: this.eventTableSelectedIds,
            handleIdea: ''
          }).then(res => {
            if (res.code === 200) {
              this.getHistoryEventList()
              this.$message({
                type: 'success',
                message: '提交成功!'
              })
            } else {
              this.$message({
                type: 'error',
                message: '提交失败!'
              })
            }
          })
        })
      }
    },
    // 处理显示告警事件弹窗提交
    handleShowEventModalSubmit() {
      this.showEventModalOpen = false
      this.eventTableCurrentRow.handled = 1
    },
    // 处理显示告警事件弹窗取消提交
    handleShowEventModalCancel() {
      this.showEventModalOpen = false
    },
    // 处理告警事件弹窗提交
    handleHandleAlarmEventModalSubmit() {
      this.handelAlarmEventModalOpen = false
      this.eventTableCurrentRow.handled = 1
    },
    // 处理告警事件弹窗取消提交
    handleHandleAlarmEventModalCancel() {
      this.handelAlarmEventModalOpen = false
    }
    // 统计分析页面------------------------------------------------------------------------------------------------
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/fireFightingSystem/FireFightingSystem.js